import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=bad6558c&scoped=true&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bad6558c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bad6558c')) {
      api.createRecord('bad6558c', component.options)
    } else {
      api.reload('bad6558c', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=bad6558c&scoped=true&", function () {
      api.rerender('bad6558c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Header/Header.vue"
export default component.exports